import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
//import { JwtHelper } from '@angular/core';
import * as jwt from 'jsonwebtoken';


// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { User } from '../../../core/auth/_models/user.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {map} from 'rxjs/operators';
import { from, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_UserS_URL = '/api/login';
@Injectable({
  providedIn: 'root'
})
export class AuthhService {
  router: any;
  // loggedIn = false;
  // isAdmin = false;



  // baseUrl ='http://localhost:3000/api';


  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) { }





  login(email):Observable<any[]>{
  //return this.http.post(`${this.baseUrl}/login`,{email})
   const httpHeaders = this.httpUtils.getHTTPHeaders(); 
  //console.log(email);
   return this.http.post<any[]>(API_UserS_URL, email, {headers: httpHeaders});
  }





  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem(environment.authTokenKey);
    return (authToken !== null) ? true : false;
  }

  getAccessToken() {
    return localStorage.getItem(environment.authTokenKey);
  }

  logout() {
    if (localStorage.removeItem('access_token') == null) {
      this.router.navigate(['users/login']);
    }
  }

  

  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }


}
